import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {

  staticAssetsUrl = environment.staticScripts.staticAssets + 'assets/icons/generic/logo-banco-falabella.png';

  constructor() { }
}
